import { render } from "./BookmarkModal.vue?vue&type=template&id=268db201&scoped=true"
import script from "./BookmarkModal.vue?vue&type=script&lang=js"
export * from "./BookmarkModal.vue?vue&type=script&lang=js"

import "./BookmarkModal.vue?vue&type=style&index=0&id=268db201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268db201"]])

export default __exports__